import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import RestablecerContrasenia from "@ConfiguracionSistema/General/RestablecerContrasenia/RestablecerContrasenia";
import AccesoUsuario from "@ConfiguracionSistema/General/AccesoUsuario/AccesoUsuario";
import ExcepcionSubOpcionRolMenu from "@ConfiguracionSistema/AccesosMenu/ExcepcionSubOpcionRolMenu/ExcepcionSubOpcionRolMenu";
import ExcepcionUsuarioMenuSubOpcion from "@ConfiguracionSistema/AccesosMenu/ExcepcionUsuarioMenuSubOpcion/ExcepcionUsuarioMenuSubOpcion";
import PermisoRolMenu from "@ConfiguracionSistema/AccesosMenu/PermisoRolMenu/PermisoRolMenu";
import ClasificacionMenu from "@ConfiguracionSistema/MenuOpciones/ClasificacionMenu/ClasificacionMenu";
import OpcionesMenu from "@ConfiguracionSistema/MenuOpciones/OpcionesMenu/OpcionesMenu";
import SubOpcionesMenu from "@ConfiguracionSistema/MenuOpciones/SubOpcionesMenu/SubOpcionesMenu";
import RegistroProgramas from "@ConfiguracionSistema/Sistema/RegistroProgramas/RegistroProgramas";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _testing_ from "@Funciones/testing";
import "./ConfiguracionSistema.css";

function ConfiguracionSistema() {
  const {
    ecv_u,
    cv_u,
    esComputadora,
    opcionMenu,
    eopcionMenu,
    navegacion,
    enavegacion,
    usuarioSesion,
    rolUsuarioSesion,
  } = useContext(Contexto);
  const [configuraciones, econfiguraciones] = useState({
    RESCONTRASENIA: <RestablecerContrasenia />,
    ACCESOSISTEMA: <AccesoUsuario />,
    PROGIMG: <RegistroProgramas />,
    CLASIFIC: <ClasificacionMenu />,
    OPMENU: <OpcionesMenu />,
    SUBOPMENU: <SubOpcionesMenu />,
    PERMROLMENU: <PermisoRolMenu />,
    EXCEPSUBOPROLMENU: <ExcepcionSubOpcionRolMenu />,
    EXCEPUSUMENUSUBOPE: <ExcepcionUsuarioMenuSubOpcion />,
  });
  const [categorias, ecategorias] = useState(
    ["AMAYTA", "ASUCASAIRE"].includes(usuarioSesion)
      ? [
          {
            titulo: "Configuración General del Sistema",
            opciones: [
              { prog: "RESCONTRASENIA", dsc: "Restablecer Contraseña de Usuarios" },
              {
                prog: "ACCESOSISTEMA",
                dsc: "Accesos de Usuario al Sistema (Habilitar o Bloquear)",
              },
            ],
          },
          {
            titulo: "Configuración del Componentes (Desarrollador)",
            opciones: [{ prog: "PROGIMG", dsc: "Registrar Programas e Imágenes" }],
          },
          {
            titulo: "Configuración del Menú de Opciones",
            opciones: [
              { prog: "CLASIFIC", dsc: "Clasificaciones del Menú" },
              {
                prog: "OPMENU",
                dsc: "Opciones del Menú",
              },
              {
                prog: "SUBOPMENU",
                dsc: "Sub-Opciones del Menú",
              },
            ],
          },
          {
            titulo: "Accesos al Menú de Opciones",
            opciones: [
              { prog: "PERMROLMENU", dsc: "Permisos de Rol a Menú" },
              {
                prog: "EXCEPSUBOPROLMENU",
                dsc: "Excepción de Sub-Opción de Rol a Menú",
              },
              {
                prog: "EXCEPUSUMENUSUBOPE",
                dsc: "Excepción de Usuario a Menú y Sub-Opción",
              },
            ],
          },
        ]
      : [
          {
            titulo: "Configuración General del Sistema",
            opciones: [
              { prog: "RESCONTRASENIA", dsc: "Restablecer Contraseña de Usuarios" },
              {
                prog: "ACCESOSISTEMA",
                dsc: "Accesos de Usuario al Sistema (Habilitar o Bloquear)",
              },
            ],
          },
        ],
  );

  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    modal_boton_cerrar_visible: true,
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_texto: "",
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    procesandoAccion_texto: "",
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_texto: "",

    //CERAR SESION
    exitoCerrarSesion: false,
  });
  const [v_u, ev_u] = useState({
    confSeleccionada: "",
  });
  useEffect(() => {}, []);
  return (
    <div className="ConfiguracionSistemaCSS-contenedor">
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: false,
            });
          }}>
          {configuraciones[v_u.confSeleccionada]}
        </ModalInformacion>
      )}
      {categorias.map((categoria, idx_categoria) => {
        return (
          <div key={idx_categoria} className="ConfiguracionSistemaCSS-categoria">
            <div className="ConfiguracionSistemaCSS-cabecera">{categoria.titulo}</div>

            <div className="ConfiguracionSistemaCSS-cuerpo">
              {categoria?.opciones?.map((opcion, idx_opcion) => {
                return (
                  <div
                    key={idx_opcion}
                    className="ConfiguracionSistemaCSS-opcion"
                    onClick={() => {
                      console.log("op:", opcion?.prog);
                      _f_.asignar(ev_c, {
                        modal_mostrar: true,
                        modal_titulo: opcion?.dsc,
                        modal_estilos: { anchoMI: "90%", altoMI: "90%" },
                      });
                      _f_.asignar(ev_u, { confSeleccionada: opcion?.prog });
                    }}>
                    {opcion.dsc}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ConfiguracionSistema;
